(function () {
    'use strict';

    angular
        .module('app.notes')
        .directive('notesCell', notesCell);

    notesCell.$inject = [ 'opsIncludeVersion']
    /* @ngInject */
    function notesCell(opsIncludeVersion) {
        
        var directive = {
            restrict: 'A',
            link: link,
            scope: {
                'item': '=',
                'notes': '='
              
            },
            templateUrl: 'app/notes/_notesCell.html?v=' + opsIncludeVersion
        };

        return directive;


        function link(scope, element, attrs) {
            
        }
    }

})();
